import styled from "styled-components";

export const ThumbnailContainerDiv = styled.div`
    height: 1000px;
    width: 800px;
    position: fixed;
    top: 1000px;
    z-index: -10;
    transform: scale(0.5);
    overflow: hidden;
`;

export const ThumbnailIFrame = styled.iframe`
    height: 1000px;
    width: 800px;
    overflow: hidden;
`;
